import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    uploadDocumentData:{},
    error:'',
    status:'idle',
    uploadDocument:{},
    deleteDocumentResponse:{}
};

export const fetchUploadedDocument = createAsyncThunk('fetch-document/fetchUploadedDocument', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/getClientByCompanyId',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const uploadDocument = createAsyncThunk('fetch-document/uploadDocument', async (initialPost) => {
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("drivers_license",initialPost.drivers_license);
    fromData.append("social_security",initialPost.social_security);
    fromData.append("proof_of_address",initialPost.proof_of_address);
    fromData.append("Token",accessToken);
    let response = await axios.post('form/uploadPersonalDocuments',fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const setSkipDocuments = createAsyncThunk('fetch-document/setSkipDocuments', async (skipped) => {
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("skip_documents",skipped);
    fromData.append("Token",accessToken);
    let response = await axios.post('form/setSkipPersonalDocuments',fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const deleteDocumentApi = createAsyncThunk('fetch-document/deleteDocument', async (initialPost) => {
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("doc_type",initialPost.doc_type);
    fromData.append("Token",accessToken);
    let response = await axios.post('Form/deletePersonalDocs',fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const UploadDocumentSlice = createSlice({
    name:'fetch-document',
    initialState,
    reducers:{
        blankUploadDocument:(state)=>{
            state.uploadDocumentData = {};
            state.uploadDocument = {};
            state.status='idle';
        },
        blankDeleteDocument:(state)=>{
            state.deleteDocumentResponse = {};
        }

    },
    extraReducers:(builder) => {
        builder.addCase(fetchUploadedDocument.pending, (state)=>{
            state.status = 'loading';
        })
        builder.addCase(fetchUploadedDocument.fulfilled,(state,action)=>{
            state.status = 'succeeded';
            state.uploadDocumentData = action.payload;
            state.error = '';
        })
        builder.addCase(fetchUploadedDocument.rejected,(state,action)=>{
            state.status = 'failed';
            state.uploadDocumentData = {};
            state.error = action.error.message;
        })
        builder.addCase(uploadDocument.fulfilled,(state,action)=>{
            state.uploadDocument = action.payload
        })
        builder.addCase(deleteDocumentApi.fulfilled,(state,action)=>{
            state.deleteDocumentResponse = action.payload
        }) 
    }
});

export const {blankUploadDocument,blankDeleteDocument} = UploadDocumentSlice.actions;

export default UploadDocumentSlice.reducer;
